import { LISTING_RIGHTS_LIMIT } from '@inflip/contracts/admin';
import { useEffect, useState } from 'react';

import { Field, SavedAt, usePlatformSettings } from '../components/settings-form';
import { Button, ErrorBanner, LoadingRow, PageHeader, Section, inputCls } from '../components/ui';
import { api } from '../lib/api-client';

/** IP 상품 설정 — 상품 하나에 등록할 수 있는 권리 수. 웹·앱 등록 폼과 서버 검사가 이 값을 따른다 */
export function ListingSettingsPage() {
  const { session, settings, error, run } = usePlatformSettings();
  const [maxRights, setMaxRights] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);
  const [savedAt, setSavedAt] = useState<Date | null>(null);

  useEffect(() => {
    if (settings && maxRights === null) setMaxRights(String(settings.listing.maxRightsPerListing));
  }, [settings, maxRights]);

  if (!session) return null;

  const save = async () => {
    if (maxRights === null || saving) return;
    setSaving(true);
    setSavedAt(null);
    const ok = await run(() =>
      api.updateListingSettings(session.accessToken, { maxRightsPerListing: Number(maxRights) }),
    );
    if (ok) setSavedAt(new Date());
    setSaving(false);
  };

  return (
    <main className="mx-auto w-full max-w-3xl px-6 py-8">
      <PageHeader
        title="IP 상품 설정"
        description="판매자가 IP 상품을 등록할 때 따르는 규칙이에요. 바꾸면 웹·앱에 바로 적용돼요"
        actions={
          <>
            <SavedAt at={savedAt} />
            <Button disabled={saving || maxRights === null} onClick={() => void save()}>
              {saving ? '저장 중…' : '저장'}
            </Button>
          </>
        }
      />
      {error && <ErrorBanner message={error} />}
      {!settings && !error && <LoadingRow />}

      {maxRights !== null && (
        <Section title="권리 수">
          <Field
            label="상품 하나에 등록할 수 있는 권리 수"
            hint={`1~${LISTING_RIGHTS_LIMIT}개. 1이면 상품마다 권리 하나만 고를 수 있어요. 이미 이보다 많이 올린 상품은 그대로 두고, 권리를 새로 더하는 것만 막아요`}
          >
            <input
              type="number"
              min={1}
              max={LISTING_RIGHTS_LIMIT}
              className={`w-36 ${inputCls}`}
              value={maxRights}
              onChange={(e) => setMaxRights(e.target.value)}
            />
          </Field>
        </Section>
      )}
    </main>
  );
}
